import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { splitAndTrim } from "../../../helpers";
import TextField from "@mui/material/TextField";
import { TABLE_NAME  as tableName } from "../../../helpers";

const normalizeFilterValue = (rawValue) => {
  if (Array.isArray(rawValue)) {
    return rawValue.join(", ");
  }
  return rawValue || "";
};


const createTextColumnFilter =
  () =>
  ({ value, header, handleFilterSet }) => {
     const [updatedValue, setUpdatedValue] = useState(() => normalizeFilterValue(value));
    
    useEffect(() => {
      setUpdatedValue(normalizeFilterValue(value));
    }, [value]);

    const { t } = useTranslation();
    
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        const newValue = e.target.value;
        if (!newValue || newValue.trim() === "") {
          handleFilterSet([]);
          setUpdatedValue("");
          return;
        }
        handleFilterSet(splitAndTrim(newValue));
         setUpdatedValue(newValue);
      }
    };

    const handleChange = (e) => {
      const newValue = e.target.value || undefined;
      setUpdatedValue(newValue);
      
      if (!newValue || newValue.trim() === "") {
        handleFilterSet([]);
      }
    };

    return (
      <TextField
        size="small"
        fullWidth
        sx={{ mb: 1 }}
        label={`Search ${tableName[header]}`}
        value={updatedValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={t('text_place_holder')}
        title={t('text_title')}
      />
    );
  };

const createTextColumnEditor =
  () =>
  ({ value, onBlur }) => {
    const [updatedValue, setUpdatedValue] = useState(value);
    const timeoutRef = useRef(null);

    useEffect(() => {
      setUpdatedValue(value);
    }, [value]);

    useEffect(() => {
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }, []);

    const handleSeparateComma = (newValue) => {
      setUpdatedValue(newValue);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        onBlur(newValue);
      }, 5000);
    };

    return (
      <TextField
        size="small"
        fullWidth
        sx={{ mb: 1 }}
        value={updatedValue || ""}
        onChange={(e) => handleSeparateComma(e.target.value || undefined)}
      />
    );
  };

export { createTextColumnFilter, createTextColumnEditor };